import { useEffect, useState } from "react";
import Reports from "../components/reports";
import { RF_ISSUES_STATION_REPORT_DATA } from "../constants/data.cnst";
import { TABLE_COLUMNS_CONFIG, type ColumnMeta } from "../constants/table.cnst";
import type { RF_ISSUES_STATION_REPORT } from "../interfaces/dashboard";

export default function RFIssuesStation() {
    const rfIssuesStationReportTableColumns: ColumnMeta[] = TABLE_COLUMNS_CONFIG.RF_ISSUES_STATION_REPORT;

    const [rfIssuesStationReportTableData, setRFIssuesStationReportTableData] = useState<RF_ISSUES_STATION_REPORT[]>([]);

    useEffect(() => {
        setRFIssuesStationReportTableData(RF_ISSUES_STATION_REPORT_DATA)
    }, []);

    return (
        <Reports
            reportType="RF_ISSUES_STATION"
            tableColumns={rfIssuesStationReportTableColumns}
            tableData={rfIssuesStationReportTableData} />
    );
}